<ng-container [ngSwitch]="iconName">
    <ng-container *ngSwitchCase="'xls'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="description"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'csv'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="description"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'ppt'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="note"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'doc'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="text_snippet"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'pdf'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="picture_as_pdf"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'img'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="image"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'zip'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="insert_drive_file"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'json'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="integration_instructions"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'file'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="insert_drive_file"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'refresh'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="refresh"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'search'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="search"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'menu'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="more_vert"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'add'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="add"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'back'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="arrow_back"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'xml'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="integration_instructions"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchCase="'html'">
        <material-button
            buttonType="icon"
            [size]="'small'"
            prefixIcon="integration_instructions"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <material-button
            buttonType="icon"
            [size]="'small'"
            [prefixIcon]="iconName"
            [titleText]="tooltip"
            (buttonClicked)="onTrigger.emit()"
        ></material-button>
    </ng-container>
</ng-container>
